import { useState, useEffect, useSyncExternalStore } from "react";
import { getPendingSyncCount } from "@/lib/offlineDb";
import { onSyncChange } from "@/lib/syncService";

function subscribe(callback: () => void) {
  window.addEventListener("online", callback);
  window.addEventListener("offline", callback);
  return () => {
    window.removeEventListener("online", callback);
    window.removeEventListener("offline", callback);
  };
}

function getSnapshot() {
  return navigator.onLine;
}

export function useOnlineStatus() {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}

export function usePendingSyncCount() {
  const [count, setCount] = useState(0);

  useEffect(() => {
    getPendingSyncCount().then(setCount);
    const unsub = onSyncChange(setCount);
    // Also poll occasionally
    const interval = setInterval(() => {
      getPendingSyncCount().then(setCount);
    }, 5000);
    return () => {
      unsub();
      clearInterval(interval);
    };
  }, []);

  return count;
}
